import React from "react";
import { Link } from "react-router";
import { UserData } from "../../types/type";

interface PersonalInfoProps {
  user?: UserData;
}

export default function PersonalInfo({ user }: PersonalInfoProps) {
  return (
    <div className='flex flex-col w-4/5 sm:w-4/5 lg:w-2/3 m-4'>
      <div className='bg-white flex flex-col p-4 rounded-t-md'>
        <h1 className='text-xl font-bold'>Personal Information</h1>
        <div className='flex flex-col space-y-3 mt-4 mb-4'>
          <div className='flex flex-row items-center justify-start border-b-2 border-[#E0E0E0]'>
            <p className='w-1/3'>Username</p>
            <p className='text-[#757575]'>{user?.username}</p>
          </div>
          <div className='flex flex-row items-center justify-start border-b-2 border-[#E0E0E0]'>
            <p className='w-1/3'>Email</p>
            <p className='text-[#757575]'>{user?.email}</p>
          </div>
          <div className='flex flex-row items-center justify-start border-b-2 border-[#E0E0E0]'>
            <p className='w-1/3'>Password</p>
            <p className='text-[#757575]'>************</p>
          </div>
        </div>
      </div>
      <div className='flex justify-end bg-[#D9D9D9] w-full rounded-b-md space-x-5 px-3 py-2'>
        <Link to='/profile/reset-password'>
          <button className='bg-[#0275D8] text-xs text-white rounded-md p-2 hover:bg-[#0256A1]'>
            Change Password
          </button>
        </Link>
        <Link to='/profile/edit-info' state={{ user }}>
          <button className='bg-[#0275D8] text-xs text-white rounded-md p-2 hover:bg-[#0256A1]'>
            Edit Personal Info
          </button>
        </Link>
      </div>
    </div>
  );
}
